import { render } from "./Sound.vue?vue&type=template&id=5c2335e6"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"

import "./Sound.vue?vue&type=style&index=0&id=5c2335e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__